import { RuleProps } from 'types/application';
export const SECT_TYPE = 'payment';
export const BILLING_DETAILS = 'billing-details';
export const BILLING_ADDRESS = 'billing-address';
export const PAYMENT_LICENCE = 'payment-licence';

export const LICENCE_PAYMENT = [
    {
        sectionID: BILLING_DETAILS,
        sectionName: 'Billing Person Details',
        fieldList: [
            {
                id: 'name',
                label: 'Name',
                type: 'text'
            },
            {
                id: 'designation',
                label: 'Designation',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text',
                rule: { required: true, charLength: 32 },
                isNextEmpty: true
            },
            {
                id: 'telNumber',
                label: 'Office Tel Number',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_DETAILS}-telNumber`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isTVROFDEL = baseValues?.[`${BILLING_DETAILS}-licenceName`] === 'Film (Distribution/Exhibition) Licence' || baseValues?.[`${BILLING_DETAILS}-licenceName`] === 'TV Receive-Only System Licence';
                        return isTVROFDEL;
                    }
                }
            },
            {
                id: 'mobileNo',
                label: 'Mobile Number',
                type: 'postal',
                rule: { 
                    required: true,
                    baseIds: [`${BILLING_DETAILS}-mobileNo`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isTVROFDEL = baseValues?.[`${BILLING_DETAILS}-licenceName`] === 'Film (Distribution/Exhibition) Licence' || baseValues?.[`${BILLING_DETAILS}-licenceName`] === 'TV Receive-Only System Licence';
                        return isTVROFDEL;
                    }
                }
            },
            {
                id: 'contactNumber',
                label: 'Contact Number',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_DETAILS}-contactNumber`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const isTVROFDEL = baseValues?.[`${BILLING_DETAILS}-licenceName`] === 'Film (Distribution/Exhibition) Licence' || baseValues?.[`${BILLING_DETAILS}-licenceName`] === 'TV Receive-Only System Licence';
                        return !isTVROFDEL;
                    }
                }
            }
        ]
    },
    {
        sectionID: BILLING_ADDRESS,
        sectionName: 'Billing Address',
        fieldList: [
            {
                id: 'address-type',
                label: 'Address Type',
                type: 'text',
                span: 12
            },
            {
                id: 'foreign-address-line-one',
                label: 'Foreign Address Line 1',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${BILLING_ADDRESS}-address-type`];
                        const result = Boolean(addressType === 'Singapore' || addressType === '' || addressType === null);
                        return result;
                    }
                }
            },
            {
                id: 'foreign-address-line-two',
                label: 'Foreign Address Line 2',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${BILLING_ADDRESS}-address-type`];
                        const result = Boolean(addressType === 'Singapore' || addressType === '' || addressType === null);
                        return result;
                    }
                }
            },
            {
                id: 'foreign-address-line-three',
                label: 'Foreign Address Line 3',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${BILLING_ADDRESS}-address-type`];
                        const result = Boolean(addressType === 'Singapore' || addressType === '' || addressType === null);
                        return result;
                    }
                }
            },
            {
                id: 'city',
                label: 'City',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${BILLING_ADDRESS}-address-type`];
                        const result = Boolean(addressType === 'Singapore' || addressType === '' || addressType === null);
                        return result;
                    }
                }
            },
            {
                id: 'state',
                label: 'State',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${BILLING_ADDRESS}-address-type`];
                        const result = Boolean(addressType === 'Singapore' || addressType === '' || addressType === null);
                        return result;
                    }
                }
            },
            {
                id: 'zip-code',
                label: 'Zip Code',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${BILLING_ADDRESS}-address-type`];
                        const result = Boolean(addressType === 'Singapore' || addressType === '' || addressType === null);
                        return result;
                    }
                }
            },
            {
                id: 'country',
                label: 'Country',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const addressType = baseValues?.[`${BILLING_ADDRESS}-address-type`];
                        const result = Boolean(addressType === 'Singapore' || addressType === '' || addressType === null);
                        return result;
                    }
                }
            },
            {
                id: 'building',
                label: 'Building Name',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    charLength: 66,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${BILLING_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'Postal',
                label: 'Postal Code',
                type: 'postal',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    required: true,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${BILLING_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'street',
                label: 'Street Name',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    required: true,
                    charLength: 32,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${BILLING_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'block-house',
                label: 'Block/House No.',
                type: 'text',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${BILLING_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'floor',
                label: 'Floor No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: 01, B1, 01M',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    charLength: 3,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${BILLING_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                }
            },
            {
                id: 'unit',
                label: 'Unit No.',
                type: 'text',
                span: 2,
                placeholder: 'Eg: #05-01, use 01',
                rule: {
                    baseIds: [`${BILLING_ADDRESS}-address-type`],
                    charLength: 5,
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${BILLING_ADDRESS}-address-type`] === 'Foreign');
                        return result;
                    }
                },
                isNextEmpty: true
            }
        ]
    },
    {
        sectionID: PAYMENT_LICENCE,
        sectionName: 'GIRO Details',
        rule: {
            baseIds: [`${PAYMENT_LICENCE}-doYouWantYourRenewalBePaidThroughGiro`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${PAYMENT_LICENCE}-doYouWantYourRenewalBePaidThroughGiro`] === '');
                return result;
            }
        },
        fieldList: [
            {
                id: 'doYouWantYourRenewalBePaidThroughGiro',
                label: 'Do you want your renewal to be paid through GIRO?',
                type: 'text',
                span: 12
            },
            {
                id: 'doYouHaveAnExistingGiroArrangementWithImda',
                label: 'Do you have an existing GIRO arrangement with IMDA?',
                type: 'text',
                span: 12,
                rule: {
                    baseIds: [`${PAYMENT_LICENCE}-doYouWantYourRenewalBePaidThroughGiro`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${PAYMENT_LICENCE}-doYouWantYourRenewalBePaidThroughGiro`] !== 'Yes'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'bank',
                label: 'Bank Name',
                type: 'text',
                rule: {
                    baseIds: [`${PAYMENT_LICENCE}-doYouHaveAnExistingGiroArrangementWithImda`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${PAYMENT_LICENCE}-doYouHaveAnExistingGiroArrangementWithImda`] !== 'Yes'
                        );
                        return result;
                    }
                }
            },
            {
                id: 'bankAccountNumber',
                label: 'Bank Account Number',
                type: 'text',
                rule: {
                    baseIds: [`${PAYMENT_LICENCE}-doYouHaveAnExistingGiroArrangementWithImda`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(
                            baseValues && baseValues[`${PAYMENT_LICENCE}-doYouHaveAnExistingGiroArrangementWithImda`] !== 'Yes'
                        );
                        return result;
                    }
                }
            }
        ]
    },
    {
        sectionID: PAYMENT_LICENCE,
        sectionName: 'Vendors@Gov Setup',
        rule: {
            baseIds: [`${PAYMENT_LICENCE}-doYouRequireEInvoiceOnVendorsGov`],
            hidden: ({ baseValues }: RuleProps) => {
                const result = Boolean(baseValues && baseValues[`${PAYMENT_LICENCE}-doYouRequireEInvoiceOnVendorsGov`] === '');
                return result;
            }
        },
        fieldList: [
            {
                id: 'doYouRequireEInvoiceOnVendorsGov',
                label: 'Do you require an e-invoice on Vendors@Gov',
                type: 'text'
            },
            {
                id: 'subBusinessUnitCode',
                label: 'Sub-Business Unit',
                type: 'text',
                rule: {
                    baseIds: [`${PAYMENT_LICENCE}-doYouRequireEInvoiceOnVendorsGov`],
                    hidden: ({ baseValues }: RuleProps) => {
                        const result = Boolean(baseValues && baseValues[`${PAYMENT_LICENCE}-doYouRequireEInvoiceOnVendorsGov`] === 'No');
                        return result;
                    }
                }
            }
        ]
    }
];
